// @flow
import * as React from 'react';

import Link from '../../components/core/Link';
import { ACCESS_LEVEL_DOCS } from '../../../common/support/accessControlConstants';

type Props = any;

export function AccessLevelTooltip(props: Props) {
  return (
    <span>
      <span>
        Choose what level of settings and data your team member has access to.{' '}
      </span>
      <Link href={ACCESS_LEVEL_DOCS} testid="access-role__docs-link">
        Learn more
      </Link>
      <span>.</span>
    </span>
  );
}
